import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Cabinet } from 'landings/cabinet';
import { RemoteProps } from './widgets-types';

export const CabinetRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Cabinet />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);

